import axios from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                alert('Session expired. Please log in again.');
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
            }

            // Handle 403 Forbidden errors
            if (error.response.status === 403) {
                const errorMessage = error.response.data?.message;

                alert(errorMessage || 'You do not have permission to perform this action.');

                if (errorMessage === 'You do not have permission to view this user.') {
                    window.location.href = '/userList';
                }
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
